import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  confirmDialogWrapper: {
    maxWidth: 600,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
  },
  confirmDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '28px',
    color: theme.palette.text.primary,

    '& svg': {
      marginRight: 5,
    },

    '& button': {
      minWidth: 0,
    },
  },

  confirmDialogTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  confirmDialogContent: {
    padding: 16,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '24px',
    color: theme.palette.text.primary,

    '& p': {
      margin: 0,
    },

    '& p + p': {
      marginTop: 8,
    },
  },
  confirmDialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px 16px',
  },
}));
